import { socketService } from '@common/core-layer/services/socket.service'

import { ChatSocketEvent } from '../types/chats.enums'

import type { ConversationEventPayload, SendMessagePayload } from '../types/socket.types'

class ChatsSocketService {
  sendMessage(locationId: string, payload: SendMessagePayload) {
    socketService.emit(
      'message',
      {
        event: 'sendMessage', // This is the socket.io event name, not ChatSocketEvent
        payload,
        locationId,
      },
      {
        queueIfDisconnected: true,
        dedupeKey: payload.uniqueRefId,
      }
    )
  }

  sendConversationEvent(locationId: string, payload: ConversationEventPayload) {
    socketService.emit('message', {
      event: ChatSocketEvent.CONVERSATION_EVENTS,
      payload,
      locationId,
    })
  }
}

export const chatsSocketService = new ChatsSocketService()
